import { render, staticRenderFns } from "./FormModelDisplay.vue?vue&type=template&id=6fb72fbb&"
import script from "./FormModelDisplay.vue?vue&type=script&lang=ts&"
export * from "./FormModelDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports